<script>
import { avatarColors } from "../../utils/avatarColors";
import LegoChatBox from "./LegoChatBox.vue";

export default {
  props: {
    cardId: {
      type: String,
      required: false,
    },
  },
  components: {
    LegoChatBox,
  },
  computed: {
    card() {
      return this.$store.state.lego.card;
    },
    userLoggedIn() {
      return this.$store.getters.userLoggedIn;
    },
    filteredChats() {
      if (this.card.assignments) {
        let data = this.card.assignments.filter((assignment) => {
          const nameNormalized = this.removeAccents(
            assignment.collaborator.name.toLowerCase()
          );
          const searchNormalized = this.removeAccents(
            this.inputSearch.toLowerCase()
          );

          const matchesSearch = nameNormalized.includes(searchNormalized);
          const isNotCurrentUser =
            assignment.collaborator.personaId !== this.userLoggedIn.id;

          return matchesSearch && isNotCurrentUser;
        });
        console.log(data);

        return data;
      } else {
        return [];
      }
    },
    lastMessage() {
      return (chat) => {
        const data = this.unreadMessages.find(
          (item) => item.userId === chat.collaborator.personaId
        );
        // console.log("lastMessage", data);

        return data ? data.lastMessage : "Inicia la conversación";
      };
    },
    unreadCount() {
      return (chat) => {
        const data = this.unreadMessages.find(
          (item) => item.userId === chat.collaborator.personaId
        );
        // console.log("unreadCount", data);

        return data ? data.unreadCount : 0;
      };
    },
    lastMessageDate() {
      return (chat) => {
        const data = this.unreadMessages.find(
          (item) => item.userId === chat.collaborator.personaId
        );
        // console.log("lastMessageDate", data);

        return data ? data.lastMessageDate : "";
      };
    },
    lastMessageReadByRecipient() {
      return (chat) => {
        const data = this.unreadMessages.find(
          (item) => item.userId === chat.collaborator.personaId
        );
        // console.log("lastMessageReadByRecipient", data);

        return data ? data.lastMessageReadByRecipient : false;
      };
    },
  },
  data() {
    return {
      isFocusText: false,
      inputSearch: "",
      selectedChat: {},
      activeChatId: null,
      currentMessages: [],
      unreadMessages: [],
      pageSize: 20, // Número de mensajes por carga
      pageNumber: 1, // Página actual
      allMessagesLoaded: false, // Bandera para saber si ya no hay más mensajes
      loadingMessages: false,
      showChatList: true,
    };
  },
  mounted() {
    this.fetchUnReadMessages();
  },
  methods: {
    getAvatarColor(idx) {
      return avatarColors(idx);
    },
    toFocusText() {
      this.isFocusText = true;
      const input = this.$refs.search;
      input.focus();
    },

    async markMessagesAsRead() {
      try {
        const res = await this.$store.dispatch("hl_post", {
          path: `Lego/chat/markAsRead/${this.userLoggedIn.id}/${this.selectedChat.receiverId}`,
        });

        console.log(res);

        if (!res) {
          throw new Error("Error al marcar mensajes como leídos");
        }

        this.fetchUnReadMessages();
      } catch (error) {
        console.error("Ha ocurrido un error:", error);
      }
    },

    async fetchUnReadMessages() {
      try {
        const res = await this.$store.dispatch("hl_get", {
          path: `Lego/chat/unreadByCard/${this.cardId}/${this.userLoggedIn.id}`,
        });

        console.log("Mensajes no leídos recibidos:", res);

        if (!res) {
          throw new Error("Error al obtener mensajes");
        }

        this.unreadMessages = res;
      } catch (error) {
        console.error("Error al obtener mensajes:", error);
      }
    },

    async fetchMessages(loadMore = false) {
      try {
        this.loadingMessages = true;
        console.log(
          `Solicitando mensajes - Página: ${this.pageNumber}, Tamaño: ${this.pageSize}`
        );

        const res = await this.$store.dispatch("hl_get", {
          path: `Lego/chat/${this.cardId}/${this.userLoggedIn.id}/${this.selectedChat.receiverId}?pageSize=${this.pageSize}&pageNumber=${this.pageNumber}`,
        });

        console.log("Mensajes recibidos:", res);

        if (!res || res.length === 0) {
          console.log("No hay más mensajes para cargar.");
          this.allMessagesLoaded = true;
          return;
        }

        if (loadMore) {
          // Si se están cargando más mensajes, agregarlos al inicio sin modificar la posición del scroll
          this.currentMessages = [...res, ...this.currentMessages];
        } else {
          // Si es la primera carga, solo establecer los mensajes
          this.currentMessages = res;
        }

        this.$nextTick(() => {
          if (this.$refs.chatBox && !loadMore) {
            this.$refs.chatBox.scrollToBottom(true); // Solo hacer scroll automático si no estamos cargando más mensajes
          }
        });
      } catch (error) {
        console.error("Error al obtener mensajes:", error);
      } finally {
        this.loadingMessages = false;
      }
    },
    async loadMoreMessages() {
      if (!this.allMessagesLoaded) {
        const chatMessages =
          this.$refs.chatBox.$el.querySelector(".chat-messages");
        if (!chatMessages) return;

        // 1. Quitar "scroll-behavior: smooth" temporalmente
        chatMessages.style.scrollBehavior = "auto";

        // 2. Guardar scrollTop y altura previa antes de cargar
        const oldScrollTop = chatMessages.scrollTop;
        const oldHeight = chatMessages.scrollHeight;

        // 3. Llamar a la API (fetchMessages) para prepend de mensajes
        this.pageNumber++;
        await this.fetchMessages(true); // true indica que agregas al inicio

        // 4. Una vez que Vue ha re-renderizado, ajusta el scroll
        this.$nextTick(() => {
          const newHeight = chatMessages.scrollHeight;
          chatMessages.scrollTop = oldScrollTop + (newHeight - oldHeight);

          // 5. (Opcional) Restaurar el comportamiento “smooth” si lo necesitas
          chatMessages.style.scrollBehavior = "smooth";
        });
      } else {
        console.log("No hay más mensajes por cargar.");
      }
    },
    handleSelectChat(chat) {
      const { collaborator } = chat;
      this.selectedChat = {
        legoCardId: this.cardId,
        receiverId: collaborator.personaId,
        senderId: this.userLoggedIn.id,
        isRead: false,
        name: collaborator.name,
      };

      this.fetchMessages();
      this.activeChatId = collaborator.personaId;
      this.markMessagesAsRead();

      if (window.innerWidth < 768) {
        // Solo ocultar lista en móvil
        this.showChatList = false;
      }
    },
    removeAccents(str) {
      return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    },
    closeChat() {
      this.selectedChat = {};
      this.activeChatId = null;
      this.currentMessages = [];
      this.pageNumber = 1;
      this.allMessagesLoaded = false;

      if (window.innerWidth < 768) {
        // Mostrar lista al cerrar en móvil
        this.showChatList = true;
      }
    },
    updateMessagesInChat(newMessage) {
      console.log("Nuevo mensaje recibido en el padre:", newMessage);

      const index = this.unreadMessages.findIndex(
        (item) => item.userId === newMessage.userId
      );

      if (index !== -1) {
        // Actualizar el mensaje existente
        this.$set(this.unreadMessages, index, newMessage);
      } else {
        // Agregar un nuevo mensaje
        this.unreadMessages = [...this.unreadMessages, newMessage];
      }
    },
    handleSendedMessage(newMessage) {
      console.log("Mensaje enviado:", newMessage);

      this.currentMessages.push(newMessage);
    },
    formatMessageTime(timestamp) {
      const messageDate = new Date(timestamp);
      const now = new Date();

      // Obtener solo las fechas sin la hora
      const messageDay = messageDate.toDateString();
      const today = now.toDateString();

      // Obtener la fecha de ayer
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      const yesterdayDay = yesterday.toDateString();

      if (messageDay === today) {
        // Hoy -> Solo mostrar la hora
        return messageDate.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        });
      } else if (messageDay === yesterdayDay) {
        // Ayer -> Mostrar "Ayer"
        return "Ayer";
      } else if (now - messageDate < 7 * 24 * 60 * 60 * 1000) {
        // Dentro de la última semana -> Mostrar "Lunes"
        return messageDate.toLocaleDateString("es-ES", { weekday: "long" });
      } else {
        // Más de una semana atrás -> Mostrar "DD/MM/YYYY"
        return messageDate.toLocaleDateString("es-ES", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
      }
    },
  },
};
</script>
<template>
  <div class="row px-2">
    <div class="col-12 col-md-4 m-0 p-0 content-left" :class="{ 'd-none d-md-block': !showChatList }">
      <!-- buscador -->
      <div class="wrapper-input-text">
        <input v-model="inputSearch" @blur="isFocusText = false" type="text" class="input"
          placeholder="Busca una conversación" ref="search" />
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="icon-search">
          <path
            d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z" />
        </svg>
      </div>
      <!-- chats -->
      <div class="chats">
        <div class="chat" v-for="(chat) in filteredChats" :key="chat.id" @click="handleSelectChat(chat)"
          :class="{ active: chat.collaborator.personaId === activeChatId }">
          <div class="chat-avatar">
            <vs-avatar size="35" class="lego-vs-avatar" :color="getAvatarColor(chat.collaborator.personaId)">
              <template #text> {{ chat.collaborator.name }}</template>
            </vs-avatar>
          </div>
          <div class="chat-detail">
            <div class="chat-header-detail">
              <span class="chat-user">
                {{ chat.collaborator.name }}
              </span>
              <small>
                {{
                  lastMessageDate(chat) &&
                  formatMessageTime(lastMessageDate(chat))
                }}
              </small>
            </div>
            <div class="chat-body">
              <span class="chat-text">
                {{ lastMessage(chat) }}
              </span>

              <template v-if="!unreadCount(chat)">
                <!-- Si lastMessageReadByRecipient = true => doble check (Leído) -->
                <small v-if="lastMessageReadByRecipient(chat)" class="read-messages" title="Leído">
                  <!-- Doble check -->
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-linecap="round" stroke-linejoin="round" width="15" height="15" stroke-width="2">
                    <path d="M7 12l5 5l10 -10"></path>
                    <path d="M2 12l5 5m5 -5l5 -5"></path>
                  </svg>
                </small>
                <!-- Si lastMessageReadByRecipient = false => check simple (Enviado, no leído) -->
                <small v-else-if="
                  lastMessage(chat) !== 'Inicia la conversación' &&
                  !lastMessageReadByRecipient(chat)
                " class="unread-messages" title="Enviado (no leído)">
                  <!-- Un check -->
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-linecap="round" stroke-linejoin="round" width="15" height="15" stroke-width="2">
                    <path d="M5 12l5 5l10 -10"></path>
                  </svg>
                </small>
              </template>

              <template v-else>
                <!-- Si hay mensajes no leídos, muestra el badge con el número de mensajes -->
                <small class="badge-unread">
                  {{ unreadCount(chat) }}
                </small>
              </template>
            </div>
          </div>
        </div>
        <p class="not-assigned" v-show="!filteredChats.length && !inputSearch">
          No hay usuarios asignados para conversar
        </p>
        <p class="not-found-chat" v-show="inputSearch && !filteredChats.length">
          No se encontraron resultados para "<b>{{ inputSearch }}</b>"
        </p>
      </div>
    </div>
    <div class="col p-0 m-0" :class="{ 'd-none d-md-block': showChatList }">
      <!-- Icono para volver al listado en móvil -->
      <i v-if="!showChatList" class="fas fa-chevron-left d-md-none mobile-back-icon" @click="closeChat"></i>
      <div class="content-chat-box">
        <LegoChatBox ref="chatBox" :selectedChat="selectedChat" :messages="currentMessages" :loading="loadingMessages"
          @sendedMessage="handleSendedMessage" @updateMessagesInParent="updateMessagesInChat" @closeChat="closeChat"
          @loadMoreMessages="loadMoreMessages" />
      </div>
    </div>
  </div>
</template>
<style scoped>
.mobile-back-icon {
  padding: 10px;
  font-size: 1.2rem;
  cursor: pointer;
  color: var(--lego-gris);
}

@media (min-width: 768px) {
  .mobile-back-icon {
    display: none !important;
  }
}

.content-left {
  box-shadow: 1px 0px 0px 0px rgba(0, 0, 0, 0.1);

  .dark & {
    box-shadow: 1px 0px 0px 0px rgba(255, 255, 255, 0.1);
  }
}

.not-found-chat,
.not-assigned {
  color: var(--lego-gris);
  font-size: 0.8rem;
  padding: 0.5rem;
}


.chats {
  overflow-y: auto;
  height: 470px;
  min-height: 470px;
  padding: 0 0.3rem;
}

.content-chat-box {
  height: 500px;
  min-height: 500px;
  padding-left: 1rem;
}

.chat {
  display: flex;
  align-items: center;
  padding: 0.4rem;
  margin: 0.3rem 0;
  border-radius: 5px;
  cursor: pointer;
}

.chat.active {
  background-color: var(--lego-shadow-hover);
}

.chat:hover {
  background-color: var(--lego-shadow-hover);
}

.chat-detail {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 10px;
  width: 100%;
}

.chat-header-detail,
.chat-body {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.chat-header-detail small {
  text-wrap: nowrap;
}

.badge-unread {
  background-color: #ff7857;
  font-size: 0.7rem;
  color: white;
  border-radius: 50%;
  width: 1.2rem;
  height: 1.2rem;
  min-width: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.read-messages,
.unread-messages {
  margin-left: 5px;
}

.chat-user {
  font-size: 0.8rem;
  text-align: start;
  color: black;

  .dark & {
    color: white;
  }
}

.chat-text {
  color: var(--lego-gris);
  font-size: 0.7rem;
}

.chat-user,
.chat-text {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}

.wrapper-input-text {
  margin-bottom: 0.5rem;
  border-collapse: collapse;
  padding-right: 8px;
  display: flex;
  justify-content: space-between;
  box-shadow: 0 1px 0px 0px rgba(0, 0, 0, 0.1);

  .dark & {
    box-shadow: 0 1px 0px 0px rgba(255, 255, 255, 0.1);
  }
}

.icon-search {
  width: 14px;
  fill: var(--lego-gris);
  cursor: pointer;
}

.input {
  border: none;
  padding: 5px 10px;
  background-color: transparent;
  box-sizing: border-box;
  color: black;

  .dark & {
    color: white;
  }
}

.input::placeholder {
  color: var(--lego-gris);
}

input.input {
  padding-bottom: 6px;
}
</style>
